import React from 'react';
import { Grammarly } from '@grammarly/editor-sdk-react';
import environment from '../environment';

const GrammarlyWrapper = ({ children }) => {
  return environment.grammarly.clientId ? (
    <Grammarly clientId={environment.grammarly.clientId} config={{ activation: 'immediate' }}>
      {children}
    </Grammarly>
  ) : (
    <>{children}</>
  );
};

export default GrammarlyWrapper;
